import React from "react";
import { Flex } from "theme-ui";
import { Icon } from "../Icons/Icon";
interface LoginProps {
  href: string;
  color?: string;
}

const ApplyButton = ({ href, color = "black" }: LoginProps) => {
  return (
    <a
      href={href}
      sx={{
        display: "flex",
        justifyContent: "center",
        textDecoration: "none",
        "&:hover": {
          a: {
            color: "brand.accentBlue",
          },
          span: {
            color: "brand.accentBlue",
          },
          path: {
            stroke: "brand.accentBlue",
          },
        },
      }}
    >
      <Icon
        name={"checkmark-circle"}
        alt={"Login"}
        color={color}
        size={25}
        sx={{
          mr: 1,
          strokeLinecap: "round",
          strokeLinejoin: "round",
          strokeWidth: "1.5",
        }}
      />
      <span
        sx={{
          fontWeight: "700",
          color: color,
        }}
      >
        Apply
      </span>
    </a>
  );
};

export default ApplyButton;
